import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { PickOddsState } from '../../../../../../core/picks/pick-models';
import { IBetslip } from '../../../../../bet-generation/models';
import { GroupPickHasLiveLegsError } from '../../../../errors/general/group-pick-error';
import { ComboBetValidationContext } from '../../../../models/models';
import { IComboBetBetslipValidator } from '../validators';

export class GroupPickHasLiveLegsValidator implements IComboBetBetslipValidator<GroupPickHasLiveLegsError> {
    validate(_: IBetslip, context: ComboBetValidationContext): Iterable<GroupPickHasLiveLegsError> {
        const invalidBetBuilderPickIds = context.typeContext.selectedPicks
            .filter((p) => BaseBetslipGroupPick.isPick(p) && p.oddsState === PickOddsState.Open && p.isLive)
            .map((p) => p.id);

        return invalidBetBuilderPickIds.length ? [new GroupPickHasLiveLegsError(invalidBetBuilderPickIds)] : [];
    }
}
